/**
 * TODO - move to decorator if possible
 * @type {{_dispatch: Dispatch<S>, _uploadXHR: XMLHttpRequest, dispatch: Dispatch<S>, uploadXHR: XMLHttpRequest}}
 */
export const Proxy = new (class {
  /**
   * @type {Dispatch<S>}
   * @private
   */
  _dispatch = null;

  /**
   * @return {Dispatch<S>}
   */
  get dispatch() {
    return this._dispatch;
  }

  /**
   * @param {Dispatch<S>} value
   */
  set dispatch(value) {
    this._dispatch = value;
  }

  /**
   * @type {XMLHttpRequest}
   * @private
   */
  _uploadXHR = null;

  /**
   * @return {XMLHttpRequest}
   */
  get uploadXHR() {
    return this._uploadXHR;
  }

  /**
   * @param {XMLHttpRequest} value
   */
  set uploadXHR(value) {
    this._uploadXHR = value;
  }
})();
